import iziToast from 'izitoast/dist/js/iziToast.min.js';
import 'izitoast/dist/css/iziToast.min.css';
import Vue from 'vue';
//example setting for notification
iziToast.settings({
  timeout: 12000,
  // resetOnHover: true,]
  icon: 'font-awesome',
  displayMode: 'replace',
  // transitionIn: 'flipInX',
  // transitionOut: 'flipOutX',
  onOpening(settings, el) {},
  // onClosing: function(){
  //   console.log("callback fechou!");
  // },
});

function getIconClass() {
  return ` v-icon theme--${$theme.isDark ? 'dark' : 'light'} opacity-1`;
}

function handleArguements(params, defaultTitle) {
  switch (params.length) {
    case 0:
      throw new Error('Empty message provided to notification!');
    case 1:
      if (typeof params[0] !== 'object') {
        return {
          message: params[0],
          title: defaultTitle,
        };
      } else {
        return {
          message: defaultMsg,
          title: defaultTitle,
          ...params[0],
        };
      }
    case 2:
      if (typeof params[0] !== 'string') {
        throw new Error(
          'When supplied two arguements, first must be message string'
        );
      }
      if (typeof params[1] !== 'object') {
        if (isNaN(params[1])) {
          if (params[1].indexOf('_') > -1 || params[1].indexOf('-') > -1) {
            return {
              message: params[0],
              title: defaultTitle,
              id: params[1],
            };
          }

          return {
            message: params[0],
            title: params[1],
          };
        }

        return {
          message: params[0],
          title: defaultTitle,
          timeout: params[1],
        };
      } else {
        return {
          message: params[0],
          title: defaultTitle,
          ...params[1],
        };
      }
    case 3:
      if (typeof params[0] !== 'string') {
        throw new Error(
          'When supplied two arguements, first must be message string'
        );
      }
      if (typeof params[1] === 'object') {
        throw new Error(
          'When supplied more than two arguements, second must not be object'
        );
      }
      let options = {
        message: params[0],
        title: defaultTitle,
      };
      if (isNaN(params[1])) {
        if (params[1].indexOf('_') > -1 || params[1].indexOf('-') > -1) {
          options.id = params[1];
        } else {
          options.title = params[1];
        }
      } else {
        options.timeout = params[1];
      }

      if (typeof params[2] !== 'object') {
        if (isNaN(params[2])) {
          if (params[2].indexOf('_') > -1 || params[2].indexOf('-') > -1) {
            if (options.id) {
              throw new Error('Ambigious arguement provided for id');
            }
            options.id = params[2];
          } else {
            throw new Error('Ambigious third arguement!');
          }
        } else {
          if (options.timeout) {
            throw new Error('Ambigious arguement provided for timeout');
          }
          options.timeout = params[2];
        }
      } else {
        options = {
          ...options,
          ...params[2],
        };
      }

      return options;
    default:
      throw new Error('Send an object for further modification');
  }
}

const toastr = {
  $showSuccess() {
    let options = handleArguements(arguments, 'Success!');
    iziToast.show({
      timeout: 6000,
      color: $theme.currentTheme.success,
      theme: $theme.isDark ? 'dark' : 'light',
      icon: `fas fa-check-circle ${getIconClass()}`,
      ...options,
    });
  },
  $showError() {
    let options = handleArguements(arguments, 'Oops!');

    if (window.$error401 && options.message === 'Unauthenticated') {
      delete window.$error401;
      return;
    }
    iziToast.show({
      color: $theme.currentTheme.error,
      theme: $theme.isDark ? 'dark' : 'light',
      icon: `fas fa-exclamation-circle ${getIconClass()}`,
      ...options,
    });
  },
  $showWarning() {
    let options = handleArguements(arguments, 'Warning!');
    iziToast.show({
      timeout: 6000,
      color: $theme.currentTheme.warning,
      theme: $theme.isDark ? 'dark' : 'light',
      icon: `fas fa-exclamation-triangle ${getIconClass()}`,
      ...options,
    });
  },
  $showInfo() {
    let options = handleArguements(arguments, 'Info!');
    iziToast.show({
      timeout: 6000,
      color: $theme.currentTheme.info,
      theme: $theme.isDark ? 'dark' : 'light',
      icon: `fas fa-info-circle ${getIconClass()}`,
      ...options,
    });
  },
  $question(
    message = 'Do you want to continue?',
    alertMSG = '',
    title = 'Confirm!!',
    resolveText = 'Ok',
    rejectText = 'Cancel'
  ) {
    return new Promise((resolve, reject) => {
      iziToast.show({
        message,
        title,
        messageColor: $theme.currentTheme.anchor,
        timeout: false,
        class: 'question-toast v-application d-md-inline-block',
        titleSize: '18px',
        titleLineHeight: '32px',
        titleColor: $theme.currentTheme.primary,
        position: 'center',
        closeOnEscape: false,
        displayMode: 'once',
        zindex: 999,
        close: false,
        layout: 2,
        backgroundColor: '#fff',
        theme: $theme.isDark ? 'dark' : 'light',
        overlay: true,
        overlayClose: false,
        buttons: [
          [
            `<button class="elevation-1 mr-10 font-weight-bold title v-btn v-btn--contained green  v-size--large white--text"><b>${resolveText}</b></button>`,
            function(instance, toast) {
              instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
              resolve(true);
            },
            true,
          ],
          [
            `<button class="elevation-1 font-weight-bold title v-btn v-btn--contained red v-size--large white--text">${rejectText}</button>`,
            function(instance, toast) {
              instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
              resolve(false);
            },
          ],
        ],
        onOpening(settings, el) {
          if (alertMSG) {
            const interval = setInterval(() => {
              try {
                el = el.querySelector('.iziToast-texts');
                let div = document.createElement('span');
                div.innerText = alertMSG;
                div.classList.add('warning--text', 'px-8', 'body-1', 'd-block');
                el.append(div);
                clearInterval(interval);
              } catch (e) {}
            }, 100);
          }
        },
      });
    });
  },
};

window.$showSuccess = toastr.$showSuccess;
window.$showError = toastr.$showError;
window.$showInfo = toastr.$showInfo;
window.$showWarning = toastr.$showWarning;
window.$question = toastr.$question;

export default toastr;
